import * as React from 'react';

const SvgOrderActive = (props) => (
  <svg
    width={25}
    height={25}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.712 5.254c-.586.586-.586 1.528-.586 3.414v9c0 1.886 0 2.828.586 3.414.586.586 1.528.586 3.414.586h6c1.886 0 2.828 0 3.414-.586.586-.586.586-1.528.586-3.414v-9c0-1.886 0-2.828-.586-3.414-.586-.586-1.528-.586-3.414-.586h-6c-1.886 0-2.828 0-3.414.586Zm3.414 3.414a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Zm0 4a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Zm0 4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z"
      fill="#fff"
    />
  </svg>
);

export default SvgOrderActive;
